import Card from "components/card";
import React, { useState, useEffect } from "react";
import QRCode from "react-qr-code";
import config from "utils/config";
import { getLocalStorageKey } from "utils/utils";
import { MdContentCopy } from "react-icons/md";

export default function EventScan({ onClose, onRoleSelect }) {
  const [QRCodeValue, setQRCodeValue] = useState("");
  const [selectedRole, setSelectedRole] = useState(null);
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    generateQRCode();
  }, []);

  const generateQRCode = () => {
    const eventId = getLocalStorageKey('eventId');
    setQRCodeValue(eventId);
  };

  const handleRoleSelect = (role) => {
    setSelectedRole(role);
  };

  const copyShareableLink = () => {
  const baseLink = `${config?.INVITE_BASE_URL}${QRCodeValue}`;
  const separator = baseLink.includes('?') ? '&' : '?';
  const link = `${baseLink}${separator}role=${selectedRole.toLowerCase()}`;

  navigator.clipboard.writeText(link);
  setIsCopied(true);
  setTimeout(() => setIsCopied(false), 2000);
};


  if (!selectedRole) {
    return (
      <Card>
        <div className="mt-8 flex flex-col items-center justify-center p-4">
          <h2 className="text-[1.175rem] font-bold text-navy-700 dark:text-white mb-6">
            Generate QR code for a
          </h2>
          
          <div className="w-full space-y-3">
            {['Attendee', 'Host', 'Sponsor', 'Vendor', 'VIP'].map((role) => (
              <button
                key={role}
                className="w-full py-3 px-4 bg-gray-100 hover:bg-gray-200 rounded-lg text-center font-medium"
                onClick={() => handleRoleSelect(role)}
              >
                {role}
              </button>
            ))}
          </div>
        </div>
      </Card>
    );
  }

  return (
    <Card>
      <div className="mt-8 flex flex-col items-center justify-center p-4">
        <h2 className="text-[1.075rem] font-bold text-navy-700 dark:text-white">
          {`SCAN TO JOIN AS ${selectedRole.toUpperCase()}`}
        </h2>
        {QRCodeValue && (
          <div className="mt-4 mb-6">
            <QRCode
              size={200}
              fgColor="black"
              value={`${config?.INVITE_BASE_URL}${QRCodeValue}${`${config?.INVITE_BASE_URL}${QRCodeValue}`.includes('?') ? '&' : '?'}role=${selectedRole.toLowerCase()}`}
            />
          </div>
        )}
        <button
          className="mt-4 py-2 px-4 bg-blue-500 text-white rounded-lg hover:bg-blue-600 flex items-center gap-2"
          onClick={copyShareableLink}
        >
          <MdContentCopy />
          {isCopied ? 'Copied!' : 'Copy shareable link'}
        </button>
      </div>
    </Card>
  );
}
